import { Notyf } from "notyf";
import "notyf/notyf.min.css";

class Helpers {
  static appName = "Inventory System";
  //static baseUrl = "//127.0.0.1:4000";
  static baseUrl = (
    process.env.REACT_APP_API_BASE_URL ||
    (process.env.NODE_ENV === "production" ? "/api" : "http://127.0.0.1:4000")
  ).replace(/\/$/, "");
  static authUser = JSON.parse(localStorage.getItem("user"));
  static authShop = JSON.parse(localStorage.getItem("shop"));

  static normalizeRoleName = (value = "") =>
    String(value || "").toLowerCase().replace(/[^a-z0-9]/g, "");

  static isCheckInOnlyUser = (user = this.authUser) =>
    this.normalizeRoleName(user?.user_role?.name) === "checkinonly";

  static authParentId =
    this.authUser == null
      ? ""
      : this.authUser.parent_id === 0
        ? this.authUser._id
        : this.authUser.parent_id;
  static headers = {
    headers: {
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    },
  };

  static errors = (err_array) => {
    let errors = {};
    console.log("Error Array", err_array);
    for (let i = 0; i < err_array.length; i++) {
      const key = err_array[i].param || err_array[i].path;
      if (!key) continue;
      errors[key] = err_array[i].msg;
      console.log("Error Added", errors);
    }
    return errors;
  };

  static toast = (type, message) => {
    const notyf = new Notyf();
    notyf.open({
      message: message,
      type: type,
      position: { x: "right", y: "top" },
      ripple: true,
      duration: 2000,
    });
  };

  static validate = (name, value, isRequired = false, isPhone = false) => {
    let error = "";
    if (isRequired) {
      if (value === "" || value === null) {
        error = `${name} field is required`;
      }
    } else if (isPhone) {
      if (!(typeof value == "number" && !isNaN(value))) {
        error = `${name} field must be a valid price value`;
      }
    }
    return error;
  };

  static error_response = (error) => {
    let errors = {};

    const responseData = error?.response?.data;
    const mongooseError = responseData?.error;

    if (responseData?.errors) {
      Helpers.toast("error", "Fix the errors to continue");
      errors = this.errors(responseData.errors);
    }

    if (mongooseError?.errors) {
      errors = {
        ...errors,
        ...Object.fromEntries(
          Object.entries(mongooseError.errors).map(([key, value]) => [
            key,
            value?.message || "Invalid value",
          ]),
        ),
      };
    }

    if (typeof mongooseError === "string") {
      Helpers.toast("error", mongooseError);
    } else if (mongooseError?.message) {
      Helpers.toast("error", mongooseError.message);
    }

    if (!responseData) {
      Helpers.toast("error", "Something went wrong. Please try again.");
      console.error("Unexpected error format:", error);
    }

    return errors;
  };

  static unauthenticated = (error, navigator) => {
    // Use optional chaining and check carefully if error.response.data.error exists
    if (error?.response?.data?.error === "Unauthenticated") {
      Helpers.toast("error", error.response.data.error);
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.clear();
      navigator("/");
    }
  };

  static anyErrors = (errObject) => {
    return Object.keys(errObject).length === 0 ? true : false;
  };
}

export default Helpers;
